import { z } from "zod";

import { machineSchema } from "./machine";
import { PORT_MAX, PORT_MIN } from "./constants";
import { trackSchema } from "./track";

const machineSettingsSchema = z
	.object({
		unit: z.string().optional(),
		longHeadParameters: z.object({}).passthrough().optional(),
		onTheFlyActive: z.boolean().optional(),
		glueFlapLength: z.number().optional(),
		tailFlapWidthCorrection: z.number().optional(),
		crossHeadParameters: z.object({}).passthrough().optional(),
		gantryParameters: z.object({}).passthrough().optional(),
		codeGeneratorSettings: z.object({}).passthrough().optional(),
	})
	.passthrough();

export const x4MachineRequestSchema = z.object({
	alias: z.string().optional(),
	description: z.string().optional(),
	ipOrDnsName: z.string().optional(),
	port: z.number().min(PORT_MIN).max(PORT_MAX).optional(),
	assetId: z.string().optional(),
	hasPackTags: z.boolean().optional(),
	assignedOperator: z.string().optional(),
	plcVersion: z.string().nullish(),
	printerIp: z.string().optional(),
	printerPort: z.number().min(PORT_MIN).max(PORT_MAX).optional(),
	tracks: z.array(trackSchema).optional(),
	physicalMachineSettings: machineSettingsSchema.nullish(),
});

export const x4MachineSchema = machineSchema.extend({
	printerIp: z.string().optional(),
	printerPort: z.number().optional(),
	printerEnabled: z.boolean().optional(),
	stopMachineWhenTrackEmpty: z.boolean().optional(),
});

export type X4Machine = z.infer<typeof x4MachineSchema>;
export type X4MachineRequest = z.infer<typeof x4MachineRequestSchema>;
